/* eslint-disable */ 

import React, { useState, useEffect } from 'react'
import SyntaxHighlighter from 'react-syntax-highlighter'
import { github } from 'react-syntax-highlighter/dist/esm/styles/hljs'

import svgLink from "../../images/link.svg"
import svgCopy from "../../images/copy.svg"

import { navigate, Link } from 'gatsby'

import { sortBy, findWhere  } from "underscore"

// import DataType from "./DataType"
import ArrowButton from "./ArrowButton"

import ApiMessage from "../post/ApiMessage"  

import objectsTableStyles from "./ObjectsTable.module.css"

export default function ObjectsTable({methodName, title, data, child, parent, onChange, parametersState}) {

    //console.log("data: ", data)
    // data_type, required

    // child gets rerendered because even if value inside objects are same, they are not the same during compare
    // { id: 0 } === { id: 0 } // false
    //console.log("Render child")

    ////////////////////////////////////////////////////////////////////////////////
    // use this to control state if this is localized version rendered from .md file
    let isInsideMdInitialState = false
    if(onChange === undefined){
        isInsideMdInitialState = true
    }

    const [ insideMd ] = useState(isInsideMdInitialState)    

    //console.log("methodName before: ", methodName)

    methodName = insideMd ? `md${methodName}` : methodName

    //console.log("methodName after: ", methodName)

    // remove /<>
    if(methodName){
        let formatedMethodName = methodName.replace(/[^0-9a-zA-Z_-]/g, "")
        //console.log("formatedMethodName: ", formatedMethodName)
        methodName = formatedMethodName
    }
    // str.replace("Microsoft", "W3Schools");
    ////////////////////////////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////////////////

    data = sortBy(data, 'order')

    const allClosed  = Array(data.length).fill(false)
    const allOpened  = Array(data.length).fill(true)

    // set open based on data in parametersState
    let elementsIDs = []
    let initialStates = []

    // http://localhost:8000/api-reference/streaming/#live-streams___stream__attributes--status__attributes--name-todo-rename__attributes
    // http://localhost:8000/api-reference/streaming/#live-streams___stream__attributes--status__attributes--name-//todo:-rename__attributes

    if(!insideMd){
        elementsIDs = data.map( ({name}) => {    

            // format name
            if(name){
                let formatedName = name.toLowerCase().replace(/\s/g, '-').replace(/[^0-9a-zA-Z_-]/g, "")
                name = formatedName
            }        

            // const id = parent ? `${parent}--${name}__${title.toLowerCase()}` : `${methodName}___${name}__${title.toLowerCase()}`
            //const id = parent ? `${parent}--${name.toLowerCase().replace(/\s/g, '-')}__${title.replace(/\s/g, '').toLowerCase()}` : `${methodName}___${name.toLowerCase().replace(/\s/g, '-')}__${title.replace(/\s/g, '').toLowerCase()}`
            const id = parent ? `${parent}--${name}__${title.replace(/\s/g, '').toLowerCase()}` : `${methodName}___${name}__${title.replace(/\s/g, '').toLowerCase()}`

            //console.log("ID: ", id)
            return id
        })
        //console.log("elementsIDs: ", elementsIDs)
        elementsIDs.forEach(id => {
            // check state for this id in parametersState and update it 
            let element = findWhere(parametersState, {id: id}) 
            if(element){
                initialStates.push(element.open)
            }
            
        })
    } else{
        initialStates = allClosed
    }

    // console.log("initialStates: ", initialStates)


    //console.log("initialStates: ",initialStates) // true true false

    // set 1st item from the list to open state
    // initialStates[0] = true
    
    const [open, setOpen] = useState(initialStates)

    //console.log("open: ", open) // true false false

    const [hideAllBtns, setHideAllBtns] = useState(false)
    const [expandAllBtns, setExpandAllBtns] = useState(true)
   

    useEffect(() => {

        //console.log("Update inital state as parametersState changed ", parametersState[82])
        setOpen(initialStates)

        //console.log("initialStates changed")         
    
    }, [parametersState])   

    useEffect(() => {
        //console.log("Button state changed")

        let counter = 0
        open.forEach(item => {
            if(item){
                counter++
            }
        })
        
        let areAllBtnsOpened = counter === open.length

        if(areAllBtnsOpened){
            setHideAllBtns(true)
            setExpandAllBtns(false)    
        } else{
            setHideAllBtns(false)
            setExpandAllBtns(true)
        }    

    }, [open])

    
    let elementsId = []

    // let elementsId = data.map( ({name, short_description, data_type, required, description, message, example, attributes}, index) => {

    // })

    const closeAll = () => {
        setOpen(allClosed)        
        //console.log("IDs to close: ", elementsId)
       
        if(!insideMd){
            onChange({
                type:'setClose',
                id: elementsId
            })   
        }            
    }

    const openAll = () => {
        setOpen(allOpened)
        //console.log("IDs to open: ", elementsId)
       
        if(!insideMd){
            onChange({
                type:'setOpen',
                id: elementsId
            })   
        }        
    }    

    const openBranch = (e) => {
        // https://stackoverflow.com/a/42121109/6261255
        // dummy___query_lvl_1__attributes--query.format_lvl_2__attributes--query_token__attributes

        // before we prevent defaul we must make sure this is anchor link

        const href = e.target.getAttribute('href')
        //if href is not set we do nothing
        console.log("href = ", href)
        if(href === '#' || href === null){
            e.preventDefault()
        } else{
            navigate(href)
        }       
          

        
    }      
   
    const toogleButton = (e, index, id) => {

        // data-type="name"
        const elementType = e.target.getAttribute('data-type')
        //console.log("elementType: ", elementType)
        if(elementType !== "name" && elementType !== "short_description" && elementType !== "copy-name"){

            //console.log("E: ", e.target)
            // if this was link clicked - do nothing
            const href = e.target.getAttribute('href')
            if(!href){
                let oldOpen = [...open]
                oldOpen[index] = !oldOpen[index]
                setOpen(oldOpen)   
        
                if(!insideMd){
                    onChange({
                        type:'toggle',
                        id: id
                    })
                }
            }        

            
        } 


        // let oldOpen = [...open]
        // oldOpen[index] = !oldOpen[index]
        // setOpen(oldOpen)   

        // onChange({
        //     type:'toggle',
        //     id: id
        // })
    }  

    const copyCurrentUrlToBuffer = (e) => {

        const href = e.target.getAttribute('href')

        if(href){
            // copy href to buffer, make sure document exists
            if(document && window){
                var dummy = document.createElement('input'),
                text = window.location.origin + href;        
                document.body.appendChild(dummy);
                dummy.value = text;
                dummy.select();
                document.execCommand('copy');
                document.body.removeChild(dummy);
            }
        }          
    }

    const copyNameToBuffer = (e) => {
        //console.log("copy to buffer")
        let name = e.target.closest('button').querySelector(('[data-type="name"]'))
        //console.log(name)

        if(document && window && name){
            // Clear any current selection
            const selection = window.getSelection();
            selection.removeAllRanges();

            // Select element content
            const range = document.createRange();
            range.selectNodeContents(name);
            selection.addRange(range); 
            document.execCommand('copy');
        }
    }

   // useMemo(() => computeExpensiveValue(a, b), [a, b]);
    
    const dataTable =  data.map( ({name, short_description, data_type, required, description, message, example, attributes}, index) => {
        
        // update href='#' and href=\"#\" in description
        if(description){
            description = description.split("href='#'").join("href='#' style='color:red;' title='Sorry, this content is coming soon!'")
            description = description.split("href=\"#\"").join("href='#' style='color:red;' title='Sorry, this content is coming soon!'")
        }        

        let contaierClassName = `${objectsTableStyles.itemContainer}`

        if(child){
            if(attributes){
                contaierClassName = `${objectsTableStyles.itemContainer} ${objectsTableStyles.child} ${objectsTableStyles.attributes}`
            }else{
                contaierClassName = `${objectsTableStyles.itemContainer} ${objectsTableStyles.child}`
            }
        } else{
            if(attributes){
                contaierClassName = `${objectsTableStyles.itemContainer} ${objectsTableStyles.attributes}`
            }else{
                contaierClassName = `${objectsTableStyles.itemContainer}`
            }            
        }

        // let id = `${name}__${title.toLowerCase()}`
        // if(parent){
        //     id=`${parent}--${id}`
        // }
        //const id = parent ? `${parent}--${name}__${title.toLowerCase()}` : `${name}__${title.toLowerCase()}`
        //const id = parent ? `${parent}--${name}__${title.toLowerCase()}` : `${methodName}___${name}__${title.toLowerCase()}`


        // format name
        let formatedName = ''
        if(name){
            formatedName = name.toLowerCase().replace(/\s/g, '-').replace(/[^0-9a-zA-Z_-]/g, "")
        }       

        const id = parent ? `${parent}--${formatedName}__${title.replace(/\s/g, '').toLowerCase()}` : `${methodName}___${formatedName}__${title.replace(/\s/g, '').toLowerCase()}`

        //const id = parent ? `${parent}--${name.toLowerCase().replace(/\s/g, '-')}__${title.replace(/\s/g, '').toLowerCase()}` : `${methodName}___${name.toLowerCase().replace(/\s/g, '-')}__${title.replace(/\s/g, '').toLowerCase()}`


        // let formattedMethodName = ''

        // if(methodName){
        //     formattedMethodName = methodName.replace(/[^a-zA-Z]/g, "");
        // }

        // const id = parent ? `${parent}--${name}__${title.replace(/\s/g, '').toLowerCase()}` : `${formattedMethodName}___${name}__${title.replace(/\s/g, '').toLowerCase()}`
        

        //console.log("methodName: ", methodName.replace(/[^a-zA-Z _]/g, ""))

        elementsId.push(id)

        // let buttonState = findWhere(parametersState, {id: id}).open

        //console.log("buttonState: ", buttonState)

        //console.log("LOCAL STATE")
    
        // get updated value from parametersState
        //let element = findWhere(parametersState, {id: id})
        //console.log(id, open[index], element.open) // dummy___query_lvl_1__attributes false true
        // let elementIndex = indexOf(parametersState, element)      
        //console.log(element.open)          
        

        let openState = open[index]

        // filter parametersState to filterdParametersStates 
        // let idPrefix = parent ? `${parent}` : `${methodName}___${name}`
        // let filterdParametersStates = parametersState.filter(item => item.id.startsWith(idPrefix))

    
        return (
          
            <div key={index} className={`${contaierClassName}`} id={id}>             
                <button
                    aria-expanded={openState ? "true" : "false"}
                    className={openState ? `${objectsTableStyles.item} ${objectsTableStyles.active}` : objectsTableStyles.item} 
                    onClick={(e) => toogleButton(e, index, id)}  

                    // aria-expanded={open[index] ? "true" : "false"}
                    // className={open[index] ? `${objectsTableStyles.item} ${objectsTableStyles.active}` : objectsTableStyles.item} 
                    // onClick={ () => toogleButton(index, id) }      

                    // aria-expanded={buttonState ? "true" : "false"} 
                    // className={buttonState ? `${objectsTableStyles.item} ${objectsTableStyles.active}` : objectsTableStyles.item} 
                    // onClick={ () => onChange(id) }           
                >                                       
                    <ArrowButton open={openState} />     
                    <div className={objectsTableStyles.itemHeader}>
                        {/* <a className={objectsTableStyles.itemLink} href={`#${id}`}>
                            <div className={objectsTableStyles.itemLinkSVG}>
                                <img src={svgLink} alt="link" />
                            </div>
                        </a> */}

                        {/* <Link
                            className={objectsTableStyles.itemLink}
                            to={`#${id}`}
                            onClick={copyCurrentUrlToBuffer}
                        >
                            <div className={objectsTableStyles.itemLinkSVG}>
                                <img src={svgLink} alt="link" />
                            </div>
                        </Link>             */}
                                        
                        <div className={objectsTableStyles.info}>
                            <div data-type="name" className={objectsTableStyles.itemName}>{name}</div>
                            {/* { data_type && !attributes &&
                                <div className={objectsTableStyles.itemDelimeter}>:</div>
                            }                             */}

                            { data_type && <div className={objectsTableStyles.dataType}>{data_type}</div> }

                            <div className={objectsTableStyles.extraControls}>
                                <div 
                                    data-type="copy-name"
                                    className={objectsTableStyles.itemCopySVG}
                                    onClick={copyNameToBuffer}
                                >
                                    <img src={svgCopy} alt="copy" />
                                </div>
                                <Link
                                    className={objectsTableStyles.itemLink}
                                    to={`#${id}`}
                                    onClick={copyCurrentUrlToBuffer}
                                >
                                    <div className={objectsTableStyles.itemLinkSVG}>
                                        <img src={svgLink} alt="link" />
                                    </div>
                                </Link>                                      
                            </div>

                            { required && 
                                <div className={objectsTableStyles.itemOptionalContainer}>
                                    <div className={objectsTableStyles.itemRequired}>required</div> 
                                </div>
                            }
                            { required === false && 
                                <div className={objectsTableStyles.itemOptionalContainer}>
                                    <div className={objectsTableStyles.itemOptional}>optional</div> 
                                </div>
                            }                            
                            
                            {/* <DataType data_type={data_type} required={required} />                         */}
                        </div>           
                        {/* <ArrowButton open={openState} />       */}
                        {/* <ArrowButton open={buttonState} /> */}
                    </div>
                    {
                        short_description &&
                            // <div className={objectsTableStyles.itemShortDescription}>
                            //     {short_description}
                            // </div>       
                            <div data-type="short_description" className={objectsTableStyles.itemShortDescription} dangerouslySetInnerHTML={ {__html: short_description} } />                                                   
                    }  
                </button>              

                <div className={openState ? `${objectsTableStyles.body} ${objectsTableStyles.active}` : objectsTableStyles.body} >
                {/* <div className={buttonState ? `${objectsTableStyles.body} ${objectsTableStyles.active}` : objectsTableStyles.body} > */}
                    <div 
                        className={objectsTableStyles.itemDescription} dangerouslySetInnerHTML={ {__html: description} } 
                        // onClick={openBranch} onKeyDown={openBranch} 
                        // role="button" tabIndex="0"
                        // aria-label="Description"                     
                    /> 

                    {
                        message && (
                            <ApiMessage type={message.type} >
                                {message.text}
                            </ApiMessage>  
                        )
                    }              
                    
                    { example && 
                        <SyntaxHighlighter 
                            style={github} 
                            className={objectsTableStyles.itemCodeExample}
                        >
                            {example}
                        </SyntaxHighlighter> 
                    }             

                    { attributes && <ObjectsTable data={attributes} title={title} child={true} parent={id} onChange={onChange} parametersState={parametersState} /> }  
                </div>
            </div>            

        )
    })

    return(               
        <div className={objectsTableStyles.container}>
            <div className={objectsTableStyles.header}>
                <div className={objectsTableStyles.title}>{title}</div>

                { hideAllBtns && <button onClick={ () => closeAll() } className={objectsTableStyles.toggleAllBtn}>Hide All</button> }
                { expandAllBtns && <button onClick={ () => openAll() } className={objectsTableStyles.toggleAllBtn}>Expand All</button> }                
                              
            </div>
            <div className={objectsTableStyles.list}> 
                {dataTable}
            </div>
        </div>
    )
}